import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Promoted.svg",
  "use": "Promoted.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Promoted.svg\"><path d=\"M50,52H14a6,6,0,0,1-6-6V18a6,6,0,0,1,6-6H50a6,6,0,0,1,6,6V46A6,6,0,0,1,50,52ZM44,21.998A2,2,0,0,0,41.9981,20h-13.02a1.9981,1.9981,0,1,0,0,3.9961H37.21L20.5674,40.5915a1.9895,1.9895,0,0,0,2.8047,2.8224l16.624-16.5775v8.1411a2.002,2.002,0,0,0,4.004,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol